/**
 * 接口域名的管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
}

export default base
